import { render, staticRenderFns } from "./PaymentsHome.vue?vue&type=template&id=2cebc5b4&"
import script from "./PaymentsHome.vue?vue&type=script&lang=js&"
export * from "./PaymentsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports